<template>
  <div class="border-bottom pb-3 mb-4">
    <NewsletterType
      :draft="draft"
      :newsletter-types="newsletterTypes"
      @clearedDraft="onClearedDraft"
    />

    <div class="form-group">
      <label>Color palette</label>
      <form-select
        display-property="name"
        :options="colorPalettes"
        :value="draft.steps.overview.colorPalette"
        @input="changePalette">
        <template v-slot:option="{option}">
          <div class="d-flex">
            <div class="mr-2">{{ option.name }}</div>
            <div v-for="color in option.colors" :key="color.dark+color.light" style="width: 18px; height: 18px; border-radius: 9px; border: 2px solid; display: inline-block; margin-right: .5rem;" :style="{
              'border-color': color.dark,
              'background-color': color.light,
            }"></div>
          </div>
        </template>
      </form-select>
    </div>

    <div class="form-group">
      <label>1st Image upload</label>
      <img
        v-if="draft.steps.overview.firstImage"
        :src="draft.steps.overview.firstImage.url"
        :alt="draft.steps.overview.firstImage.name"
        class="d-block mb-2"
        style="max-width: 520px;"
      >
      <FileUpload
        :value="draft.steps.overview.firstImage ? [draft.steps.overview.firstImage] : []"
        :headers="headers"
        :action="`${url}upload/image`"
        @input="pictureUploaded"
        :accept="['image/png', 'image/jpeg']"
      />
        <!--

        <div v-else>
          <icon
            icon="add-image"
            class="m-0"
          />
          <div class="el-upload__text">
            Drop your file here or <em>Browse</em>
          </div>
        </div>
      </el-upload> -->
    </div>

    <ArticlesFields
      v-model="draft.steps.overview.firstArticle"
      id="1"
      class="mt-3 mb-3 pb-3"
      :highlight-fields="highlightFields"
      disable-private
      use-bullets="marketing"
    />
  </div>
</template>

<script>
// import Autocomplete from '@/components/Autocomplete'
import he from 'he'
import NewsletterType from '../Components/NewsletterType'
import ColorInput from '../Components/ColorInput'
import ArticlesFields from '../ArticlesFields'
import {FileUpload} from '@frontend/components/src/FileUpload'
import {FormSelect} from '@frontend/components/src/FormSelect'

export default {
  name: 'MostReadOnTellimerOverviewStep',

  components: {
    // Autocomplete,
    ArticlesFields,
    NewsletterType,
    ColorInput,
    FileUpload,
    FormSelect,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    newsletterTypes: {
      type: Array,
      required: true,
    },
    highlightFields: {
      required: true,
      type: Boolean,
    },
  },

  metaInfo () {
    return {
      title: this.draft && this.draft.subject ? this.draft.subject : 'Create Newsletter',
    }
  },

  mounted () {
    if (!this.draft.steps.overview.colorPalette) {
      this.changePalette(this.colorPalettes[Math.floor(Math.random() * this.colorPalettes.length)])
    }
  },

  data () {
    const pictures = []
    const {firstImage} = this.draft.steps.overview

    if (firstImage) {
      pictures[0] = firstImage
    }

    return {
      synopsisMaxLength: 400,
      pictures,
      error: null,
      url: process.env.VUE_APP_API_ENDPOINT,
      colorPalettes: [
        {
          name: 'Palette 1',
          colors: [
            {
              dark: '#390C57',
              light: '#FFA265',
            },
            {
              dark: '#173B81',
              light: '#3DD8CD',
            },
            {
              dark: '#004958',
              light: '#FF9189',
            },
            {
              dark: '#7B0B37',
              light: '#E1B8FF',
            },
            {
              dark: '#0C4D23',
              light: '#B8CCFF',
            },
          ],
        }, {
          name: 'Palette 2',
          colors: [
          {
            dark: '#173B81',
            light: '#E1B8FF',
          },
          {
            dark: '#004958',
            light: '#FFD67A',
          },
          {
            dark: '#53117E',
            light: '#7AECE3',
          },
          {
            dark: '#004E3E',
            light: '#FFC8B8',
          },
          {
            dark: '#7B0B37',
            light: '#B8E3EF',
            },
          ]
        }, {
          name: 'Palette 3',
          colors: [
          {
            dark: '#004958',
            light: '#FA7AA5',
          },
          {
            dark: '#53117E',
            light: '#FFA265',
          },
          {
            dark: '#173B81',
            light: '#FFB8B8',
          },
          {
            dark: '#7B0B37',
            light: '#FFE4A6',
          },
          {
            dark: '#004E3E',
            light: '#EEC2DA',
            },
          ]
        }, {
          name: 'Palette 4',
          colors: [
          {
            dark: '#7B0B37',
            light: '#CDC3C2',
          },
          {
            dark: '#004958',
            light: '#FA7AA5',
          },
          {
            dark: '#173B81',
            light: '#FFB8CD',
          },
          {
            dark: '#004E3E',
            light: '#B8CCFF',
          },
          {
            dark: '#173B81',
            light: '#B8E7C5',
            },
          ]
        },
      ],
    }
  },

  computed: {
    headers () {
      return {
        Authorization: 'Bearer ' + this.$login.getToken(),
      }
    },

    colorInputFieldStyle () {
      return {backgroundColor: this.draft.steps.overview.firstBgColor || '#f46a3f'}
    },
  },

  methods: {
    update (key = '') {
      this.$emit(
          'update',
          {
            steps: {
              overview: {
                [key]: this.draft.steps.overview[key],
              },
            },
          }
      )
    },

    changePalette (palette) {
      this.draft.steps.overview.colorPalette = palette
      this.update('colorPalette')
    },

    onClearedDraft (newDraft) {
      this.$emit('clearedDraft', newDraft)
    },

    pictureUploaded (fileList) {
      const img = !fileList[0] ? null : {
        name: fileList[0].name,
        url: fileList[0].url,
      }

      this.draft.steps.overview.firstImage = img
      this.update('firstImage')
    },

    selectedArticle (selection) {
      if (selection && selection.object) {
        const {id, slug, title, analysts} = selection.object
        const data = {
          id,
          slug,
          title,
          analyst: analysts[0] ? {
            name: analysts[0].name,
            job_title: analysts[0].job_title,
            picture_url: analysts[0].user.picture_url,
            company: analysts[0].channel ? analysts[0].channel.name : null,
            slug: analysts[0].slug,
          } : null,
        }

        this.draft.steps.overview.firstArticle = data
        this.draft.steps.overview.firstTitle = selection.object.display_title
        this.draft.steps.overview.firstSynopsis = he.decode(selection.object.preview)
        this.update('firstArticle')
        this.update('firstTitle')
        this.update('firstSynopsis')
      }
    },
  },
}
</script>

